import {useCallback, useEffect, useState} from 'react';
import {
  importGlobalScript,
  loadScriptStateType,
  removeGlobalScript,
  scriptOptions,
} from './script';

export function useScript(
  src: string,
  options?: scriptOptions,
): loadScriptStateType {
  const cancel = useCallback(() => {
    return removeGlobalScript(src);
  }, [src]);

  const [loadScriptState, setLoadScriptState] =
    useState<loadScriptStateType>('idle');

  useEffect(() => {
    // eslint-disable-next-line local-rules/set-state-in-use-effect -- TODO: Cleanup setState in useEffect https://aboutyou.atlassian.net/browse/ASFE-7602
    setLoadScriptState('pending');
    async function loadScript() {
      try {
        const {isApiAvailable, ...rest} = options ?? {};
        const alreadyLoaded =
          typeof isApiAvailable === 'function' && isApiAvailable();

        if (alreadyLoaded) {
          setLoadScriptState('success');
        } else {
          await importGlobalScript(src, setLoadScriptState, rest);
        }
      } catch (e) {
        setLoadScriptState('error');
      }
    }
    loadScript();

    return cancel;
  }, [src, cancel]);

  return loadScriptState;
}
